import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
}

export default function LinkAttachIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "27"}
      height={height || "31"}
      viewBox="0 0 27 31"
    >
      <rect
        id="Rectangle_1953"
        data-name="Rectangle 1953"
        width="27"
        height="31"
        rx="5"
        fill="#f9f9f9"
      />
      <path
        id="Union_26"
        data-name="Union 26"
        d="M1.3,13.7a4.458,4.458,0,0,1,0-6.3L2.39,6.313a.469.469,0,0,1,.8.311,1.97,1.97,0,0,0,.166.935.473.473,0,0,1-.11.487l-.384.383a2.538,2.538,0,0,0-.547,3.749,2.8,2.8,0,0,0,3.89.26l2.16-2.176a2.385,2.385,0,0,0-.122-3.483,2.152,2.152,0,0,0-.3-.25.53.53,0,0,1-.2-.369c-.012-.31-.035-.417.209-.661l.418-.519a.47.47,0,0,1,.6-.051,5.263,5.263,0,0,1,.6.5,4.45,4.45,0,0,1,.01,6.287l-.01.011L7.6,13.7a4.458,4.458,0,0,1-6.3,0Zm4.73-3.625a5.449,5.449,0,0,1-.6-.5A4.45,4.45,0,0,1,5.42,3.283l.011-.011L7.4,1.3a4.453,4.453,0,0,1,6.3,6.3L12.61,8.687a.468.468,0,0,1-.8-.311,2,2,0,0,0-.166-.934.473.473,0,0,1,.111-.487l.384-.383a2.538,2.538,0,0,0,.547-3.749,2.8,2.8,0,0,0-3.891-.259L6.635,4.739a2.384,2.384,0,0,0,.12,3.482,2.354,2.354,0,0,0,.3.251.526.526,0,0,1,.2.369c.012.309.035.416-.209.66l-.418.52a.465.465,0,0,1-.33.136A.475.475,0,0,1,6.032,10.072Z"
        transform="translate(6 8)"
        fill="#707070"
      />
    </svg>
  );
}
